import {Action, combineReducers, createFeatureSelector, createSelector} from '@ngrx/store';

import * as fromGetBusinessReducer from './get-business.reducer';
import * as fromLegalEntitiesReducer from './legal-entities.reducer';
import * as fromBusinessGroupNamesReducer from './business-group-names.reducer';
import * as fromBusinessUserRolesReducer from './business-user-role.reducer';
import * as fromSetupStatusReducer from './setup-status.reducer';
import * as fromTaxNumbersReducer from './tax-numbers.reducer';
import * as fromSaveTaxNumberReducer from './save-tax-number.reducer';

export const sharedFeatureKey = 'shared';

export interface SharedState {
  [fromGetBusinessReducer.getBusinessKey]: fromGetBusinessReducer.GetBusinessState;
  [fromSetupStatusReducer.setupStatusFeatureKey]: fromSetupStatusReducer.SetupStatusState;
  [fromLegalEntitiesReducer.legalEntitiesKey]: fromLegalEntitiesReducer.LegalEntitiesState;
  [fromBusinessGroupNamesReducer.businessGroupNamesFeatureKey]: fromBusinessGroupNamesReducer.BusinessGroupNamesState;
  [fromBusinessUserRolesReducer.businessUserRoleFeatureKey]: fromBusinessUserRolesReducer.BusinessUserRoleState;
  [fromTaxNumbersReducer.taxNumbersFeatureKey]: fromTaxNumbersReducer.TaxNumbersState;
  [fromSaveTaxNumberReducer.saveTaxNumberFeatureKey]: fromSaveTaxNumberReducer.SaveTaxNumberState;
}

export interface State {
  [sharedFeatureKey]: SharedState;
}

export function reducers(state: SharedState | undefined, action: Action) {
  return combineReducers({
    [fromGetBusinessReducer.getBusinessKey]: fromGetBusinessReducer.reducer,
    [fromSetupStatusReducer.setupStatusFeatureKey]: fromSetupStatusReducer.reducer,
    [fromLegalEntitiesReducer.legalEntitiesKey]: fromLegalEntitiesReducer.legalEntitiesReducer,
    [fromBusinessGroupNamesReducer.businessGroupNamesFeatureKey]: fromBusinessGroupNamesReducer.reducer,
    [fromBusinessUserRolesReducer.businessUserRoleFeatureKey]: fromBusinessUserRolesReducer.reducer,
    [fromTaxNumbersReducer.taxNumbersFeatureKey]: fromTaxNumbersReducer.reducer,
    [fromSaveTaxNumberReducer.saveTaxNumberFeatureKey]: fromSaveTaxNumberReducer.reducer
  })(state, action);
}

export const selectRootSharedState = createFeatureSelector<State, SharedState>(sharedFeatureKey);

export const GetBusinessState = createSelector(selectRootSharedState, state => state[fromGetBusinessReducer.getBusinessKey]);
export const GetSetupStatusState = createSelector(selectRootSharedState, state => state[fromSetupStatusReducer.setupStatusFeatureKey]);
export const GetLegalEntitiesState = createSelector(selectRootSharedState, state => state[fromLegalEntitiesReducer.legalEntitiesKey]);
export const GetBusinessGroupNamesState = createSelector(selectRootSharedState, state => state[fromBusinessGroupNamesReducer.businessGroupNamesFeatureKey]);
export const GetBusinessUserRolesState = createSelector(selectRootSharedState, state => state[fromBusinessUserRolesReducer.businessUserRoleFeatureKey]);
export const GetTaxNumbersState = createSelector(selectRootSharedState, state => state[fromTaxNumbersReducer.taxNumbersFeatureKey]);
export const GetSaveTaxNumberState = createSelector(selectRootSharedState, state => state[fromSaveTaxNumberReducer.saveTaxNumberFeatureKey]);